export type Preferences={graphics:'standard'|'performance';autoTutorial:boolean};
const key='algoquest-preferences-v1';
const defaults:Preferences={graphics:'standard',autoTutorial:true};
let value={...defaults};
try{const stored=JSON.parse(localStorage.getItem(key)??'null');if(stored)value={graphics:stored.graphics==='performance'?'performance':'standard',autoTutorial:typeof stored.autoTutorial==='boolean'?stored.autoTutorial:true};}catch{}
const listeners=new Set<()=>void>();
export const preferences={
 get:()=>value,
 subscribe(fn:()=>void){listeners.add(fn);return ()=>{listeners.delete(fn);};},
 set(next:Partial<Preferences>){value={...value,...next};try{localStorage.setItem(key,JSON.stringify(value));}catch{}listeners.forEach(fn=>fn());},
};
